/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetApiPublicTabletBarbersQueryResponse, GetApiPublicTabletBarbersPathParams, GetApiPublicTabletBarbersQueryParams, GetApiPublicTabletBarbers400, GetApiPublicTabletBarbers403, GetApiPublicTabletBarbers404, GetApiPublicTabletBarbers500 } from "../entities/GetApiPublicTabletBarbers";

function getGetApiPublicTabletBarbersUrl(branch_id: GetApiPublicTabletBarbersPathParams["branch_id"]) {
  const res = { method: 'GET', url: `/api/public/tablet/barbers` as const }
  return res
}

/**
 * @description Мастера выбранного филиала с ближайшим временем записи по scoped runtime-плану. Endpoint работает только на текущий день
 * @summary Получить доступных мастеров (планшет)
 * {@link /api/public/tablet/barbers}
 */
export async function getApiPublicTabletBarbers(branch_id: GetApiPublicTabletBarbersPathParams["branch_id"], params: GetApiPublicTabletBarbersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetApiPublicTabletBarbersQueryResponse, ResponseErrorConfig<GetApiPublicTabletBarbers400 | GetApiPublicTabletBarbers403 | GetApiPublicTabletBarbers404 | GetApiPublicTabletBarbers500>, unknown>({ method : "GET", url : getGetApiPublicTabletBarbersUrl(branch_id).url.toString(), params, ... requestConfig })
  return res.data
}